<template>
  <div class="heisman">
    <v-container class="my-5">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card class="ma-3">
            <!-- <v-card-title class="accent secondary--text">Finalists</v-card-title> -->
            <v-card-text class="mt-5">
              <h2 class="font-weight-bold mb-2">Heisman Finalists</h2>
              <v-divider class="mb-6"/>
              <v-form ref="finalistsForm">
                <v-combobox
                  chips
                  :search-input.sync="search"
                  hide-selected
                  v-model="heismanPicks.finalists"
                  :items="heismanFavorites"
                  hint="Select from list of Vegas favorites or enter your own player"
                  label="Select 5 players"
                  multiple
                  persistent-hint
                  @change="updateHeismanPicks()"
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          No results matching "
                          <strong>{{ search }}</strong>". Press
                          <kbd>enter</kbd>
                          to add {{search}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md6>
          <v-card class="ma-3" v-if="heismanPicks.finalists && heismanPicks.finalists.length === 5">
            <!-- <v-card-title class="accent secondary--text">Winner</v-card-title> -->
            <v-card-text class="mt-5">
              <h2 class="font-weight-bold mb-2">Heisman Winner</h2>
              <v-divider class="mb-6"/>
              <h3
                class="my-3"
                v-if="heismanPicks.finalists && heismanPicks.finalists.length === 5"
              >Select the winner from your finalists</h3>
              <v-radio-group
                v-model="heismanPicks.winner"
                :disabled="heismanPicks.finalists && heismanPicks.finalists.length < 5"
              >
                <v-radio
                  color="error"
                  v-for="n in heismanPicks.finalists"
                  :key="n"
                  :label="`${n}`"
                  :value="n"
                  @change="updateHeismanPicks(n)"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Heisman",
  data() {
    return {
      max: 5,
      search: null
      
    };
  },
  methods: {
      updateHeismanPicks(winner) {
          this.heismanPicks.winner = winner
          this.$store.dispatch('updateHeismanPicks', this.heismanPicks)
      }
  },
  computed: {
    ...mapGetters(["heismanPicks", "heismanFavorites"])
  },
  watch: {
      'heismanPicks.finalists'(val) {
        if (val && val.length > 5) {
          this.$nextTick(() => this.heismanPicks.finalists.pop());
        }
      }
  },
  created() {
    this.$store.dispatch("fetchHeismanPicks")
  }
};
</script>